import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify/lib";
import axios from "axios";
import VueRouter from "vue-router";
import routes from "./router";
import VueCookies from "vue-cookies";
import MixinFunction from "./mixin/global/MixinFunction";
import XLSX from "xlsx";

Vue.config.productionTip = false;

const getConfig = async () => {
  const config = await fetch("/config.json");
  return await config.json();
};

// Mixin Globaux
Vue.mixin(MixinFunction);

// Gestion des Routes (URL dynamiques)
Vue.use(VueRouter);
const router = new VueRouter({
  routes: routes,
  mode: "history"
});

// Gestion des Cookies
// https://www.npmjs.com/package/vue-cookies
Vue.use(VueCookies);
VueCookies.config("7d");

import colors from "vuetify/lib/util/colors";
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#336699",
        secondary: "#d99423",
        third: "#336699",
        accent: colors.shades.black,
        error: colors.red.accent3
      },
      dark: {
        primary: "#336699"
      }
    }
  }
});

Vue.use(Vuetify);
Vue.use(XLSX);

getConfig().then(function(json) {
  Vue.prototype.$BackEndAPI = axios.create({
    baseURL: json.API_ENDPOINT,
    timeout: 30000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
  Vue.prototype.$COMPANY = json.COMPANY;
  new Vue({
    vuetify,
    render: h => h(App),
    router
  }).$mount("#app");
});
